module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [(_vm.details.nudge) ? _c('div', {
    staticClass: "col-xs-12 col-lg-10 col-lg-offset-1"
  }, [_c('p', [_c('strong', [_vm._v("Category: ")]), _c('span', [_vm._v(_vm._s(_vm.details.nudge.category))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Message: ")]), _c('span', [_vm._v(_vm._s(_vm.details.nudge.message.eng))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("From: ")]), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.details.nudge.dateFrom)))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("To: ")]), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.details.nudge.dateTo)))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Requires Response: ")]), _c('span', [_vm._v(_vm._s(_vm.details.nudge.requiresResponse))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Description: ")]), _c('span', [_vm._v(_vm._s(_vm.details.nudge.description))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Statistics Response")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.details.stats), function(each, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(each.response || 'No Response'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(each.number))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        A NUDGE\n        "), _c('small', [_vm._v("View A Nudge Statistics")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("A Nudge Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Response")]), _vm._v(" "), _c('th', [_vm._v("Count")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-436bdc2b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge/viewANudge.vue
// module id = 0oJ5
// module chunks = 1